import { __awaiter } from "tslib";
import services from '@/services/index';
import { i18n } from '@/main';
import { getPassportUrl } from '@/utils/other';
const namespaced = true;
class State {
    constructor() {
        this.extendedKysStatus = null;
        this.isAuthenticated = false;
        this.userCountryISO = null;
        this.userData = {
            confirmation: 'sms',
            email: '',
            first_name: '',
            last_name: '',
            patronymic: '',
            phone: '',
            promo: '',
            pk: 0,
            uuid: '',
            currentAccessRepairMethods: [],
            verificationRights: {
                currentLevelMonthLimit: null,
                currentRecovery: null,
                isNewUser: true,
                levelName: '',
                regFeatures: {
                    apiKeyUsing: false,
                    bybitAlpha: false
                }
            },
            permissions: {
                binance: {},
                bybit: {},
                screener: {
                    available: false
                }
            },
            docs: undefined
        };
    }
}
const getters = {
    getIsAuthenticated: state => state.isAuthenticated,
    getUserCountryISO: (state) => state.userCountryISO,
    getUserData: state => state.userData,
    isUiBlocking: state => { var _a, _b, _c; return !!((_b = (_a = state.userData.docs) === null || _a === void 0 ? void 0 : _a.userUnsignedDocuments) === null || _b === void 0 ? void 0 : _b.length) && !((_c = state.userData.docs) === null || _c === void 0 ? void 0 : _c.docsPermission); },
    extendedKycStatus: state => state.extendedKysStatus
};
// const setBitrixChatData = (userData: any) => {
//   const dataString = {
//     type: {
//       name: userData.first_name,
//       'last-name': userData.last_name,
//       phone: userData.phone,
//       email: userData.email
//     },
//     name: {
//       CONTACT_NAME: userData.first_name,
//       CONTACT_LAST_NAME: userData.last_name,
//       CONTACT_PHONE: userData.phone,
//       CONTACT_EMAIL: userData.email
//     }
//   }
//   localStorage.setItem('bitrix-chat-data', JSON.stringify(dataString))
// }
const actions = {
    loadUser({ commit }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield services.authorization.loadUser(null);
            const kycUserData = yield services.authorization.getKycUserData(null);
            if (response.success) {
                commit('setUserData', response.data);
                commit('setIsAuthenticated', true);
                // setBitrixChatData(response.data)
            }
            if (kycUserData.success) {
                const extendedStatus = kycUserData.data.extended.status;
                commit('setExtendedKycStatus', extendedStatus);
            }
            return response;
        });
    },
    documentsNotification({ dispatch }, docs) {
        if (docs.userUnsignedDocuments.length === 0)
            return;
        const numberDocuments = docs.userUnsignedDocuments.length === 1 ? i18n.t('popups.document') : i18n.t('popups.documents');
        const buttonText = docs.userUnsignedDocuments.length === 1 ? i18n.t('popups.goToDocument') : i18n.t('popups.goToDocuments');
        const checkUnsignedDocuments = (nameDocument) => {
            return docs.userUnsignedDocuments.some((document) => document === nameDocument);
        };
        const unsignedDocs = [];
        if (checkUnsignedDocuments('termsOfUse'))
            unsignedDocs.push(i18n.t('popups.termsOfUse'));
        if (checkUnsignedDocuments('privacyPolicy'))
            unsignedDocs.push(i18n.t('popups.privacyPolicy'));
        if (checkUnsignedDocuments('riskWarning'))
            unsignedDocs.push(i18n.t('popups.riskWarning'));
        if (checkUnsignedDocuments('cookiePolicy'))
            unsignedDocs.push(i18n.t('popups.cookiePolicy'));
        if (checkUnsignedDocuments('buddy'))
            unsignedDocs.push(i18n.t('popups.buddy'));
        const documentsNames = unsignedDocs.join(', ');
        dispatch('alertsBus/openAlert', {
            title: i18n.t('popups.documentsTitle', { document: numberDocuments }),
            content: i18n.t('popups.documentsText', { document: numberDocuments, documentName: documentsNames }),
            type: 'info',
            autoDelete: false,
            wordBreak: true,
            action: {
                text: buttonText,
                position: 'bottom',
                callback: () => __awaiter(this, void 0, void 0, function* () {
                    yield services.authorization.acceptUserDocs();
                    window.location.href = getPassportUrl('/id/legal-information', { withAcceptor: true });
                })
            },
            onClose: () => {
                services.authorization.acceptUserDocs();
            }
        }, { root: true });
    },
    loadAccessInfo({ commit, state }) {
        return __awaiter(this, void 0, void 0, function* () {
            const recoveryId = state.userData.verificationRights.currentRecovery;
            if (!recoveryId)
                return;
            const getAccessInfo = yield services.mainService.getAccessInfo({ recoveryId });
            if (!getAccessInfo.success)
                return;
            commit('setCurrentAccessRepairMethods', getAccessInfo.data.currentRecoveryTypes);
        });
    }
};
const mutations = {
    setIsAuthenticated(state, payload) {
        state.isAuthenticated = payload;
    },
    setUserCountryISO(state, payload) {
        state.userCountryISO = payload;
    },
    setUserData(state, payload) {
        state.userData = Object.assign(Object.assign({}, state.userData), payload);
    },
    setCurrentAccessRepairMethods(state, payload) {
        state.userData.currentAccessRepairMethods = payload;
    },
    setExtendedKycStatus(state, payload) {
        state.extendedKysStatus = payload;
    }
};
export default {
    namespaced,
    state: new State(),
    actions,
    getters,
    mutations
};
